import React, { useCallback } from "react";
import TitleItem from "../../../../viewer/chart/TitleItem.tsx";
import { argumentAxisTitle } from "../../../../viewer/chart/style/argumentAxis/argumentAxisTitle.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";
interface Props {
  settings: ChartStyleSettings;
  readonlyMode: boolean;
}

export default function Title({ settings, readonlyMode }: Props) {
  const title = React.useMemo(() => argumentAxisTitle(settings), [settings]);
  const dispatch = useAppDispatch();

  const updateArgumentAxis = useCallback(
    (title: string | undefined) => {
      dispatch(fieldsStateActions.updateAxisArgumentSettings({ title }));
    },
    [dispatch]
  );

  return (
    <TitleItem title={title} placeholder="Set Axis Title..." disabled={readonlyMode} onUpdate={updateArgumentAxis} />
  );
}
